import React, { Component } from 'react';
import { connect, batch } from 'react-redux';
import { bindActionCreators } from 'redux';
import S from 'StyledAccountCashback.js';
import Loader from 'Loader.js';
import Datepicker from 'Datepicker.js';
import Pagination from 'Pagination.js';
import { translation, formatMoney } from 'utilsHelper.js';
import { formatDate } from 'helpers/datesHelper.js';
import {
  changeDateByType,
  changeActiveTab,
  fetchCashbackByFilter,
  setCurrentPage,
} from 'accountCashbackActions.js';
import CalendarIcon from 'calendar_icon.png';
import { proccessFrontError } from 'errorActions.js';

class AccountCashback extends Component {
  constructor(props) {
    super(props);
    this.dateStartRef = React.createRef();
    this.dateEndRef = React.createRef();
  }

  componentDidMount = async () => {
    const accountBonusSelector = document.querySelector('.account-cashbacks');
    if (accountBonusSelector) {
      accountBonusSelector.addEventListener('click', this.handleOutsideClick, false);
    }

    const { fetchCashbackByFilter, processFrontError } = this.props;
    try {
      await fetchCashbackByFilter();
    } catch (error) {
      processFrontError(error, 'AccountCashback.componentDidMount');
    }
  };

  componentWillUnmount = () => {
    const accountBonusSelector = document.querySelector('.account-cashbacks');
    if (accountBonusSelector) {
      accountBonusSelector.removeEventListener('click', this.handleOutsideClick, false);
    }
  };

  handleChangeStart = (date) => {
    const { changeDateByType, fetchCashbackByFilter } = this.props;
    const startDate = new Date(date);

    batch(() => {
      changeDateByType('startDate', startDate);
      fetchCashbackByFilter();
    });
  };

  handleChangeEnd = (date) => {
    const { changeDateByType, fetchCashbackByFilter } = this.props;
    const endDate = new Date(date);

    batch(() => {
      changeDateByType('endDate', endDate);
      fetchCashbackByFilter();
    });
  };

  onChangeFilter = (activeTab) => {
    const { changeActiveTab, fetchCashbackByFilter } = this.props;

    batch(() => {
      changeActiveTab(activeTab);
      fetchCashbackByFilter();
    });
  };

  goPage = (currentPage) => {
    const { fetchCashbackByFilter, setCurrentPage, processFrontError } = this.props;
    try {
      batch(() => {
        setCurrentPage(currentPage);
        fetchCashbackByFilter();
      });
    } catch (error) {
      processFrontError(error, 'AccountCashback.goPage');
    }
  };

  handleOutsideClick = (e) => {
    const datePickerPopperSelector = document.querySelector('.react-datepicker-popper');
    if (datePickerPopperSelector && !datePickerPopperSelector.contains(e.target)) {
      this.dateEndRef?.current?.setOpen(false);
      this.dateStartRef?.current?.setOpen(false);
    }
  };

  render() {
    const { isPending, startDate, endDate, status, currencyCode, activeTab, cashback, limit } =
      this.props;
    const activeCashback = cashback[activeTab];
    const { data, isNextPageAvailable, currentPage } = activeCashback;

    return (
      <S.AccountCashback className="account-cashbacks">
        <S.AccountCashbackTitle>{translation('account_cashback_title')}</S.AccountCashbackTitle>

        <S.CashbackFilters>
          <S.CashbackFiltersBtns>
            <S.FilterBtn
              isActive={status == 'paid'}
              onClick={this.onChangeFilter.bind(this, 'paid')}
            >
              {translation('account_cashback_paid')}
            </S.FilterBtn>
            <S.FilterBtn
              isActive={status == 'awaiting'}
              onClick={this.onChangeFilter.bind(this, 'awaiting')}
            >
              {translation('account_cashback_awaiting')}
            </S.FilterBtn>
          </S.CashbackFiltersBtns>

          <S.FiltersDates className="bet-history-filters-dates">
            <S.DateLabel
              dangerouslySetInnerHTML={{ __html: translation('account_betHistory_dateRange') }}
            />

            <S.DateWrapper className="date-wrapper">
              <S.DateIconWrapper>
                <S.DateIcon src={CalendarIcon} />
              </S.DateIconWrapper>

              <Datepicker
                disabled={status == 'active'}
                ref={this.dateStartRef}
                selected={startDate}
                selectsStart
                dateFormat="dd-MM-yyyy"
                cb={this.handleChangeStart}
                popperPlacement="bottom"
              />
            </S.DateWrapper>

            <S.DateWrapper className="date-wrapper">
              <S.DateIconWrapper>
                <S.DateIcon src={CalendarIcon} />
              </S.DateIconWrapper>

              <Datepicker
                disabled={status == 'active'}
                ref={this.dateEndRef}
                minDate={startDate}
                selected={endDate}
                selectsEnd
                dateFormat="dd-MM-yyyy"
                cb={this.handleChangeEnd}
                popperPlacement="bottom"
                startDate={startDate}
                endDate={endDate}
              />
            </S.DateWrapper>
          </S.FiltersDates>
        </S.CashbackFilters>

        <S.CashbackListWrapper>
          {isPending ? (
            <Loader />
          ) : (
            <>
              {data.length > 0 ? (
                <>
                  <S.CashbackList>
                    {data.map((cashback) => {
                      const {
                        betSlipId,
                        createTime,
                        offerId,
                        paidValue = 0,
                        nameKey,
                        offerName,
                      } = cashback;

                      const cashbackItem = (
                        <S.CashbackItem key={offerId}>
                          <S.CashbackHeader>
                            <S.CashbackTitle>{translation(offerName)}</S.CashbackTitle>
                          </S.CashbackHeader>

                          <S.CashbackBody>
                            <S.CashbackBox>
                              <S.CashbackBoxTitle>
                                {translation('account_cashback_betSlipId')}
                              </S.CashbackBoxTitle>
                              <S.CashbackBoxValue>{betSlipId}</S.CashbackBoxValue>
                            </S.CashbackBox>

                            <S.CashbackBox>
                              <S.CashbackBoxTitle>
                                {translation('account_cashback_createTime')}
                              </S.CashbackBoxTitle>
                              <S.CashbackBoxValue>
                                {formatDate(createTime, 'yyyy-MM-dd HH:mm')}
                              </S.CashbackBoxValue>
                            </S.CashbackBox>

                            <S.CashbackBox>
                              <S.CashbackBoxTitle>
                                {translation('account_cashback_offerName')}
                              </S.CashbackBoxTitle>
                              <S.CashbackBoxValue>{translation(nameKey)}</S.CashbackBoxValue>
                            </S.CashbackBox>

                            <S.CashbackBox>
                              <S.CashbackBoxTitle>
                                {translation('account_cashback_paidValue')}
                              </S.CashbackBoxTitle>
                              <S.CashbackBoxValue>
                                {formatMoney(paidValue)} {currencyCode}
                              </S.CashbackBoxValue>
                            </S.CashbackBox>
                          </S.CashbackBody>
                        </S.CashbackItem>
                      );

                      return cashbackItem;
                    })}
                  </S.CashbackList>

                  <Pagination
                    {...{
                      isNextPageAvailable,
                      data,
                      currentPage,
                      limit,
                      callback: this.page,
                    }}
                  />
                </>
              ) : (
                <S.NoResult>{translation('account_cashbacks_noResult')}</S.NoResult>
              )}
            </>
          )}
        </S.CashbackListWrapper>
      </S.AccountCashback>
    );
  }
}

const mapStateToProps = ({
  AccountCashback: { isPending, error, startDate, endDate, activeTab, limit, cashback },
  Auth: {
    user: { currencyCode },
  },
}) => {
  return {
    error,
    isPending,
    startDate,
    endDate,
    activeTab,
    limit,
    currencyCode,
    cashback,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    changeActiveTab: bindActionCreators(changeActiveTab, dispatch),
    changeDateByType: bindActionCreators(changeDateByType, dispatch),
    fetchCashbackByFilter: bindActionCreators(fetchCashbackByFilter, dispatch),
    setCurrentPage: bindActionCreators(setCurrentPage, dispatch),
    processFrontError: bindActionCreators(proccessFrontError, dispatch),
    dispatch,
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(AccountCashback);
